/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnWorldCompleteSsoRequestModel } from '../../models/learn-world-complete-sso-request-model';
import { LearnWorldCompleteSsoResponseModel } from '../../models/learn-world-complete-sso-response-model';

export interface LearnWorldCompleteSsoPost$Params {
      body?: LearnWorldCompleteSsoRequestModel
}

export function learnWorldCompleteSsoPost(http: HttpClient, rootUrl: string, params?: LearnWorldCompleteSsoPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<LearnWorldCompleteSsoResponseModel>> {
  const rb = new RequestBuilder(rootUrl, learnWorldCompleteSsoPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<LearnWorldCompleteSsoResponseModel>;
    })
  );
}

learnWorldCompleteSsoPost.PATH = '/LearnWorld/CompleteSso';
